import { FieldTypeEnum, OperatorEnum } from '../../../../../shared/enums';

export const FieldOperators: Record<FieldTypeEnum, { operators: OperatorEnum[] }> = {
  [FieldTypeEnum.STRING]: {
    operators: [OperatorEnum.EQ, OperatorEnum.NEQ, OperatorEnum.IS_NOT_EMPTY, OperatorEnum.IS_EMPTY]
  },
  [FieldTypeEnum.BOOLEAN]: {
    operators: [OperatorEnum.EQ],
  },
  [FieldTypeEnum.ENUM]: {
    operators: [OperatorEnum.IN, OperatorEnum.NOT_IN, OperatorEnum.IS_NOT_EMPTY, OperatorEnum.IS_EMPTY]
  },
  [FieldTypeEnum.DATE]: {
    operators: [OperatorEnum.LT, OperatorEnum.LTE, OperatorEnum.GT, OperatorEnum.GTE, OperatorEnum.BETWEEN, OperatorEnum.IS_NOT_EMPTY, OperatorEnum.IS_EMPTY]
  },
  [FieldTypeEnum.DATETIME]: {
    operators: [OperatorEnum.LT, OperatorEnum.LTE, OperatorEnum.GT, OperatorEnum.GTE, OperatorEnum.BETWEEN, OperatorEnum.IS_NOT_EMPTY, OperatorEnum.IS_EMPTY]
  },
  [FieldTypeEnum.NUMBER]: {
    operators: [OperatorEnum.EQ, OperatorEnum.NEQ, OperatorEnum.LT, OperatorEnum.LTE, OperatorEnum.GT, OperatorEnum.GTE, OperatorEnum.BETWEEN, OperatorEnum.IS_NOT_EMPTY, OperatorEnum.IS_EMPTY]
  },
  [FieldTypeEnum.UNKNOWN]: {
    operators: []
  }
};
